export function isFacelessReelPreviewUser() {
  return true;
}
